import React, {useEffect, useState} from 'react';
import {Tooltip} from "@material-ui/core";
import ComingSoonIconSettings from "./ComingSoonIconSettings";
import {useDispatch, useSelector} from "react-redux";
import {bbFindUserTagsByTagId} from "../../../util/bbHelpers";
import {disableBRLabs, enableBRLabs} from "../../../actions";

const BRLabFeaturesOptIn=({customerId = null})=>{

    const authUser = useSelector(({auth}) => auth.authUser);
    const dispatch = useDispatch();
    // const isAdmin = isCurrentUserMemberOf(authUser,"admin");
    // const isStaff = isCurrentUserMemberOf(authUser, "staff");

    const isDisabled = true;
    const textColor = isDisabled ? "text-light-gray" : "";
    const labOptInTags = bbFindUserTagsByTagId(authUser, 56);

    const hasTags = labOptInTags && labOptInTags.length > 0;

    const [selected, setSelected] = useState(true);
    const [localLoading, setLocalLoading] = useState(false);

    const handleOnClick = (value)=>{

        setLocalLoading(true);

        if(!hasTags && value === true){
            setSelected(value)
            dispatch(enableBRLabs(authUser.user.id))
        } else if (hasTags && value === false){
            setSelected(value)
            dispatch(disableBRLabs(labOptInTags[0]))
        }
    }

    useEffect(()=>{
        if(authUser){
            setSelected(hasTags)
            setLocalLoading(false);
        }
    }, [dispatch, authUser, hasTags])


    return(
        <div>
            <p className={`col-11 text-center ${textColor}`} style={{marginTop: "-1%"}}>
                <p className={"m-0 p-0"}>Discover and test upcoming and experimental BreachRisk&trade; features.</p>
            </p>
            <div className={`row align-self-center ${textColor}`}>
                <Tooltip title={`Discover and test upcoming and experimental BreachRisk features.`}>
                    <>
                        <p className={"col-5 text-right align-self-center"}>View Available Lab Features:</p>
                        <p className={"col-1"}> </p>
                        <div className={"col-5 text-left"}>
                            <form className={"m-0 p-0 d-inline"}>
                                <div className={"col-6 d-inline m-0 p-0"}>
                                    <input type="radio"
                                           id="true"
                                           name={"true"}
                                           value={true}
                                           disabled={isDisabled}
                                           checked={selected === true}
                                           onClick={(e)=>handleOnClick(true)}
                                    />
                                    <label htmlFor="true">&nbsp; Yes</label>
                                </div>
                                <div className={"col-6 d-inline"}>
                                    <input type="radio"
                                           id="false"
                                           name={"false"}
                                           value={false}
                                           disabled={isDisabled}
                                           checked={selected === false}
                                           onClick={(e)=>handleOnClick(false)}
                                    />
                                    <label htmlFor="false">&nbsp; No</label>
                                </div>
                            </form>
                        </div>
                    </>
                </Tooltip>
                {isDisabled && <ComingSoonIconSettings className={"align-self-center mt-1 pt-1"}/>}
            </div>

        </div>

    )
}

export default BRLabFeaturesOptIn;